import { REQUEST_CREATE_SKILL_GROUP, RECEIVE_CREATE_SKILL_GROUP, UPDATE_CREATE_SKILL_GROUP_VALUES, CLEAR_CREATE_SKILL_GROUP_VALUES } from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { hideCreateSkillGroupModal } from './modal';
import { getBackendUrl } from '../env';


export const requestCreateSkillGroup = () => ({
    type: REQUEST_CREATE_SKILL_GROUP
})

export const receiveCreateSkillGroup = (result) => ({
    type: RECEIVE_CREATE_SKILL_GROUP,
    result: result
})

export const updateCreateSkillGroupFormValues = values => ({
    type: UPDATE_CREATE_SKILL_GROUP_VALUES,
    values: values
})

export const clearCreateSkillGroupModalValues = () => ({
    type: CLEAR_CREATE_SKILL_GROUP_VALUES
})

export const canCreateSkillGroup = (state) => {
    if(state == null){
        return false;
    }

    return true;
}

export const createSkillGroup = (state) => dispatch => {
    if(!canCreateSkillGroup(state)){
        return false;
    }

    dispatch(requestCreateSkillGroup()); // Flag to the application that we have started our request.

    //
    // Create our request's body
    //

    const payload = {
        name:  state.skillGroupName
    };

    //
    // Send our request off.
    //

        dispatch(requestCreateSkillGroup);
    (fetch(`${getBackendUrl()}/api/v1/data/skillgroup`, {method: 'POST', body: JSON.stringify(payload), headers: {'Content-Type': 'application/json'}})
        .then(getBody)
        .then(response => {
            dispatch(receiveCreateSkillGroup(response));
            dispatch(clearCreateSkillGroupModalValues());
            dispatch(hideCreateSkillGroupModal());
        }))
        .catch(err => {
            dispatch(receiveCreateSkillGroup(null));
            dispatch(displayError(err));
        });
}



// WEBPACK FOOTER //
// ./src/actions/createSkillGroup.js